import {axios, HOST, config} from './settiing';

export default {
  addMaintenance(data) {
    return axios.post(`${HOST}/resource/vehicle/maintenance`, data, config);
  },

  updateMaintenance(data) {
    return axios.put(`${HOST}/resource/vehicle/maintenance`, data, config)
  },

  deleteMaintenance(id) {
    return axios.delete(`${HOST}/resource/vehicle/maintenance/${id}`, config)
  },

  getMaintenanceList(vehicleId, notBefore, notAfter) {
    return axios.get(`${HOST}/resource/vehicle/maintenance/${vehicleId}/${notBefore}/${notAfter}`, config)
  },

  getMaintenanceListItem(vehicleId) {
    return axios.get(`${HOST}/resource/vehicle/maintenanceItem/${vehicleId}`, config)
  },
}